import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_easy_login_form = _resolveComponent("easy-login-form")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(_ctx.user.userName), 1)
        ], 64))
      : _createCommentVNode("", true),
    (!_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args))),
            class: _normalizeClass(["weight-medium", _ctx.buttonClass])
          }, [
            (_ctx.text)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.text), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('LoginButton.button-text')), 1)
                ], 64))
          ], 2),
          (_ctx.show)
            ? (_openBlock(), _createBlock(_Teleport, {
                key: 0,
                to: "#container"
              }, [
                _createVNode(_component_easy_login_form, {
                  onClose: _ctx.closeModal,
                  showCloseButton: _ctx.showCloseButton,
                  email: _ctx.email,
                  returnUrl: _ctx.returnUrl
                }, null, 8, ["onClose", "showCloseButton", "email", "returnUrl"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}